<template>
  <div class="stock-custom-query-view">
    <StockCustomQuery />
  </div>
</template>

<script>
import StockCustomQuery from '@/components/screening/StockCustomQuery.vue'

export default {
  name: 'StockCustomQueryView',
  components: {
    StockCustomQuery
  }
}
</script>

<style scoped>
.stock-custom-query-view {
  padding: 20px;
  flex: 1;
}
</style>
